var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.googleAuth)?_c('button',{staticClass:"btn btn-link ml-auto",attrs:{"type":"button"},on:{"click":_vm.login}},[_c('i',{staticClass:"fa fa-google mr-2"}),_vm._v(" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af970960","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/LoginWithGoogle.vue
// module id = u0Ka
// module chunks = 53